import { useSelector } from 'react-redux'
import {
  Box,
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { usersSelectors } from 'store'
import { ImagesPng } from 'assets/images'
import { COLORS } from 'utils/styles'

export const UserInformation = ({
  profilePicture,
  coverPicture,
  fullName
}) => {
  const { blogFormAnimationHidden } = useSelector(usersSelectors)

  return (
    <Stack
      width="100%"
      position="relative"
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      opacity={blogFormAnimationHidden ? 0 : 1}
    >
      <Box
        position="absolute"
        width="146%"
        top="-24px"
        left={-20}
        data-name="coverPicture"
        sx={{
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
          '@media (max-width: 470px)': {
            left: '-20',
            width: '100vw'
          }
        }}
      >
        <Image
          src={coverPicture || null}
          objectFit="cover"
          width="100%"
          height="95px"
        />
      </Box>

      <Stack
        alignItems="center"
        direction="row"
        spacing="14px"
        position="relative"
        width="100%"
        sx={{
          '@media (max-width: 480px)': {
            left: '-40px !important'
          }
        }}
      >
        <Image
          boxSize="65px"
          position="relative"
          objectFit="cover"
          src={profilePicture || ImagesPng.DefaultImage}
          alt="User Image"
          borderRadius="full"
          border={`1.5px solid ${COLORS.gray_op8}`}
          top="-10px"
        />
        <Stack direction="column" spacing="12px" position="relative" top="-10px" width="100%">
          <Text
            background={COLORS.transparentGray}
            p="1.5px 15px"
            borderRadius={3}
            data-name="fullName"
            width="auto"
            fontSize="17px"
          >
            {fullName}
          </Text>
        </Stack>
      </Stack>
      <Box />
    </Stack>
  )
}
